import React from "react";
import toPairs from "lodash/toPairs";
import orderBy from "lodash/orderBy";
import countBy from "lodash/countBy";
import queryString from "query-string";

const Helper = {
  reloadAdThrive() {
    try {
      if (window.googletag) {
        window.googletag.destroySlots();
        window.adthrive = undefined;
        let footerAds = document.getElementsByClassName("adthrive-sticky");
        for (let ad of footerAds) {
          ad.remove();
        }
        let footerMsg = document.getElementsByClassName(
          "adthrive-footer-message"
        );
        for (let msg of footerMsg) {
          msg.remove();
        }
      }

      (function (w, d) {
        w.adthrive = w.adthrive || {};
        w.adthrive.cmd = w.adthrive.cmd || [];
        w.adthrive.plugin = "adthrive-ads-3.0.1";
        w.adthrive.host = "ads.adthrive.com";
        w.adthrive.integration = "plugin";

        var commitParam =
          w.adthriveCLS &&
          w.adthriveCLS.bucket !== "prod" &&
          w.adthriveCLS.branch
            ? "&commit=" + w.adthriveCLS.branch
            : "";

        var s = d.createElement("script");
        s.async = true;
        s.referrerpolicy = "no-referrer-when-downgrade";
        s.src =
          "https://" +
          w.adthrive.host +
          "/sites/622f42f8688af31b50b63a81/ads.min.js?referrer=" +
          w.encodeURIComponent(w.location.href) +
          commitParam +
          "&cb=" +
          (Math.floor(Math.random() * 100) + 1) +
          "";
        var n = d.getElementsByTagName("script")[0];
        n.parentNode.insertBefore(s, n);
      })(window, document);
    } catch (error) {
      console.log("adthrive error");
    }
  },
  parseJwt(token) {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  },
  splitIntoPathAndSearch(url) {
    let split = url.split("?");
    return {
      pathname: split[0],
      search: split[1] ? "?" + split[1] : "",
    };
  },

  getMappingUrl(pathname, urlMapping) {
    return urlMapping.find((x) => x.url === pathname);
  },
  getPlayerUrl(playerName, urlMapping) {
    const match = urlMapping.find(
      (m) => queryString.parse(m.query).player === playerName
    );
    return (
      match?.url ??
      "/shoe-reviews/?" + queryString.stringify({ player: playerName })
    );
  },
  getFilterObjectFromPath(pathname, search, urlMapping) {
    let find = urlMapping.find((x) => x.url === pathname);
    if (find !== undefined) {
      return queryString.parse(find.query);
    } else {
      return queryString.parse(search);
    }
  },
  getNextUrl(filterObject, urlMapping) {
    let tempQueryString = queryString.stringify(filterObject);
    let find = urlMapping.find((x) => x.query === tempQueryString);
    if (find) {
      return find.url;
    } else {
      return "/shoe-reviews/" + Helper.addQuestionMark(tempQueryString);
    }
  },
  getSortUrl(sortBy, order = "desc") {
    return "/shoe-reviews/?" + queryString.stringify({ order, sortBy });
  },
  nextFilterObject(currentFilterObject, objectToAdd) {
    let nextObject = { ...currentFilterObject, ...objectToAdd };
    Object.entries(objectToAdd).forEach(([key, value]) => {
      if (value === "") {
        delete nextObject[key];
      }
    });
    return nextObject;
  },
  fetchShoeData(url) {
    let fetchShoeDataPromise = fetch(
      __server__ + "/API/pub/shoe_data?url=" + url,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        data.styles.forEach((style) => {
          style.colorways = data.colorways.filter(
            (colorway) => colorway.style_id === style.style_id
          );
          style.resells = data.resells.filter(
            (resell) => resell.style_id === style.style_id
          );
        });
        return { ...data, COMPLETE_LOAD: true };
      });

    let fetchSimilarShoesPromise = fetch(
      __server__ + "/API/pub/similar_shoes?url=" + url,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    return Promise.all([fetchShoeDataPromise, fetchSimilarShoesPromise]).then(
      ([shoeData, similarShoes]) => ({
        ...shoeData,
        similarShoes: similarShoes,
      })
    );
  },
  fetchShoeDataByID(shoeID) {
    return fetch(__server__ + "/API/pub/shoe_data?shoe_id=" + shoeID, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        data.styles.forEach((style) => {
          style.colorways = data.colorways.filter(
            (colorway) => colorway.style_id === style.style_id
          );
          style.resells = data.resells.filter(
            (resell) => resell.style_id === style.style_id
          );
        });
        return { ...data, COMPLETE_LOAD: true };
      });
  },
  validFilterLength(filterArray, filters) {
    let filterKeys = Object.keys(filters);
    return filterKeys.filter((x) => filterArray.map((y) => y.data).includes(x))
      .length;
  },
  addQuestionMark(x) {
    return x === "" ? x : "?" + x;
  },
  updateQueryString(currentQueryString, key, value) {
    //console.log("currentQueryString",currentQueryString);
    //console.log("key",key);
    //console.log("value",value);

    let currentQueryStringArray = queryString.parse(currentQueryString);
    if (value === "") {
      delete currentQueryStringArray[key];
    } else {
      currentQueryStringArray[key] = value;
    }

    return queryString.stringify(currentQueryStringArray);
  },
  getValueFromQueryString(currentQueryString, key) {
    let currentQueryStringArray = queryString.parse(currentQueryString);
    return currentQueryStringArray[key] ?? false;
  },
  getOffers(shoe, colorways) {
    if (colorways && colorways.length !== 0) {
      let maxPrice = Math.max(...colorways.map((x) => x.price_discount));
      return {
        offers: [
          {
            "@type": "AggregateOffer",
            highPrice: maxPrice,
            lowPrice: shoe.discount,
            priceCurrency: "USD",
            offerCount: colorways.length,
          },
        ],
      };
    } else {
      return null;
    }
  },

  printRating(rating, precision = 1) {
    if (rating === "NA") {
      return "NA";
    } else {
      if (typeof rating == "number") {
        return rating.toFixed(precision);
      } else {
        return rating;
      }
    }
  },
  unwrap_filters(filters, page = 100) {
    let result = [];
    filters.forEach((filter, index) => {
      if (index <= page) {
        filter.forEach((row) => {
          if (row !== undefined && (row.permanent != false || index == page)) {
            result.push(row);
          }
        });
      }
    });
    return result;
  },

  findShoe(shoe_id, shoes) {
    let filteredShoes = shoes.filter((shoe) => shoe.shoe_id === shoe_id);
    if (filteredShoes.length > 0) {
      return filteredShoes[0];
    } else {
      return false;
    }
  },
  sortStylesByLikes(a, b) {
    return Number(b.likes) - Number(a.likes) === 0
      ? a.style_id - b.style_id
      : Number(b.likes) - Number(a.likes);
  },
  sortStylesByPrice(a, b) {
    let returnValue = 0;
    if (a.colorways?.length > 0 && b.colorways?.length > 0) {
      returnValue = a.colorways[0].price - b.colorways[0].price;
    } else if (a.colorways?.length > 0 || b.colorways?.length > 0) {
      returnValue = b.colorways?.length - a.colorways?.length;
    } else if (a.resells?.length > 0 && b.resells?.length > 0) {
      returnValue = a.resells[0].price - b.resells[0].price;
    } else if (a.resells?.length > 0 || b.resells?.length > 0) {
      returnValue = b.resells?.length - a.resells?.length;
    }
    return returnValue === 0 ? a.style_id - b.style_id : returnValue;
  },

  sort_colorways_by_shop: (colorways) => {
    let result = [];
    if (colorways) {
      let available_shops = colorways.reduce((acc, current) => {
        if (acc.indexOf(current.shop_id) === -1) {
          return [...acc, current.shop_id];
        } else {
          return acc;
        }
      }, []);

      available_shops.forEach((shop_id) => {
        let colorways_of_this_shop = colorways.filter(
          (colorway) => colorway.shop_id === shop_id
        );
        let tempShop = {
          shop_id: shop_id,
          banner: colorways_of_this_shop[0].banner2,
          colorways: colorways_of_this_shop,
        };
        result.push(tempShop);
      });
    }

    return result;
  },

  randomString: (len, bits) => {
    bits = bits || 36;
    var outStr = "",
      newStr;
    while (outStr.length < len) {
      newStr = Math.random().toString(bits).slice(2);
      outStr += newStr.slice(0, Math.min(newStr.length, len - outStr.length));
    }
    return outStr.toUpperCase();
  },
  ratingOrderBy: (data, sortByVar, orderByVar) => {
    return orderBy(
      data,
      [
        (x) =>
          x[sortByVar] === "NA"
            ? orderByVar === "desc"
              ? -1
              : 1000
            : x[sortByVar],
        "release_date",
      ],
      [orderByVar, "desc"]
    );
  },
  capitalize: (name) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  },
  getDateString: (timestamp) => {
    let now = new Date();
    let release_date = Helper.getDateFromMysql(timestamp);
    let datediff = now - release_date;
    let start_of_today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    let time_today = now - start_of_today;
    let ms_per_day = 60 * 60 * 24 * 1000;

    if (datediff < time_today) {
      return (
        "Today at " +
        release_date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    } else if (datediff < time_today + ms_per_day) {
      return (
        "Yesterday at " +
        release_date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    } else if (datediff < time_today + 6 * ms_per_day) {
      return (
        release_date.toLocaleDateString("en-US", { weekday: "long" }) +
        " at " +
        release_date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    } else {
      return release_date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }
  },

  getShoe: (name, data) => {
    if (name === null) {
      return null;
    } else {
      let shoe = data.filter((shoe) => {
        return shoe.url === name;
      })[0];
      if (shoe === undefined) {
        return null;
      } else {
        return shoe;
      }
    }
  },

  getShoeByID: (shoeID, data) => {
    if (shoeID === null) {
      return null;
    } else {
      let shoe = data.filter((shoe) => {
        return shoe.shoe_id === shoeID;
      })[0];
      if (shoe === undefined) {
        return null;
      } else {
        return shoe;
      }
    }
  },

  getViewportWidth: () => {
    if (__isBrowser__ !== true) {
      return 0;
    } else {
      return (
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      );
    }
  },

  getBrands: (shoes) => {
    shoes = orderBy(shoes, ["rating"], ["desc"]);
    shoes = shoes.map((shoe, index) => ({ ...shoe, ranking: index + 1 }));
    shoes = orderBy(shoes, ["release_date"], ["desc"]);

    let brand_occurences = countBy(shoes.map((shoe) => shoe.brand));
    let brand_array = [];

    toPairs(brand_occurences).forEach((row) => {
      brand_array.push({ brand: row[0], amount: row[1] });
    });

    brand_array = orderBy(brand_array, ["amount"], ["desc"]);
    let orderedBrands = brand_array.map((row) => row.brand);
    let brands = [];
    orderedBrands.forEach((row) => {
      brands[row] = false;
    });
    return brands;
  },

  add_options_img: (url, width, format = "png") => {
    try {
      let file_without_format = url.substr(0, url.lastIndexOf("."));
      return (
        __cdn__ + file_without_format + "_" + width + "x" + width + "." + format
      );
    } catch (error) {
      return url;
    }
  },

  create_source_set: (image, maxWidth = 5000, format = "png") => {
    let widths = [143, 286, 585, 1170, 2048];
    let returnValue = "";

    if (image.thumbnails == "1" && image.hasOwnProperty("master")) {
      widths.forEach((width) => {
        if (width <= maxWidth) {
          returnValue +=
            Helper.add_options_img(image.master, width, format) +
            " " +
            width +
            "w,";
        }
      });
      return returnValue;
    } else {
      return image.url + " 1020w";
    }
  },

  roundto: (value, precision) => {
    return (
      Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision)
    ).toFixed(precision);
  },

  getCookie: (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },

  gaEvent: (category, action, label) => {
    //console.log(category,action,label);
    try {
      if (typeof window !== "undefined" && typeof window?.ga === "function") {
        window.ga("send", "event", category, action, label);
      } else {
        console.log("tracking error: ga not a function");
        console.log("category", category, "action", action, "label", label);
      }
    } catch (error) {
      console.log(error);
    }
  },

  ga4Event: (event, properties) => {
    /*
    console.log("in ga4event", event, properties);
    try {
      if (typeof window !== "undefined") {
        window.gtag("event", event, properties);
        console.log("gtag, event, properties", event, properties);
      }
    } catch (error) {} */
  },

  getDateFromMysql: (date) => {
    let arr = date.split(/-|\s|:/);
    let newDate = new Date(
      Date.UTC(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])
    );
    return newDate;
  },

  setCookie: (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },

  description: {
    normal: {
      width: [
        "very narrow",
        "slightly narrow",
        "regularly wide",
        "slightly wide",
        "very wide",
        "is",
      ],
      size: [
        "runs a size small",
        "runs half a size small",
        "fits true to size",
        "runs half a size large",
        "runs a size large",
        "",
      ],
    },
    short: {
      width: [
        "very narrow",
        "slightly narrow",
        "regularly wide",
        "slightly wide",
        "very wide",
        "is",
      ],
      size: [
        "runs small",
        <div>&frac12; size small</div>,
        "true to size",
        <div>&frac12; size large</div>,
        "runs large",
        "",
      ],
    },
    very_short: {
      width: ["narrow", "narrow", "regular", "wide", "wide"],
      size: [
        "runs small",
        "runs small",
        "true to size",
        "runs large",
        "runs large",
      ],
    },
  },

  insert_link: (link, u1, tracking_id) => {
    return link + "&" + tracking_id + "=" + u1;
    /*
     let linkURL=new URL(link);
     linkURL.searchParams.append(tracking_id,u1);
     return linkURL.toString();*/
  },

  getVideoID: (src, what = "thumbnail") => {
    if (what === "thumbnail") {
      return (
        "https://img.youtube.com/vi/" +
        src.substring(src.indexOf("v=") + 2, src.indexOf("v=") + 13) +
        "/mqdefault.jpg"
      );
    } else if (what === "videoID") {
      return src.substring(src.indexOf("v=") + 2, src.indexOf("v=") + 13);
    } else {
      return (
        "https://img.youtube.com/vi/" +
        src.substring(src.indexOf("v=") + 2, src.indexOf("v=") + 13) +
        "/mqdefault.jpg"
      );
    }
  },

  /*filterData:(data,filters)=>{
     console.log("called function filterData");
     let newData = [];
     let delete_row = false;

      data.forEach((shoe) => {
        delete_row = false;
        filters.forEach((filter) => {
          let temp_category,temp_value,temp_string;
          if (filter.filterType.type === "number") {
            if (!(eval("Helper.roundto(parseFloat(shoe[filter.filterType.data]),1) " + filter.sign + "=  Number(filter.args[0])"))) {
              delete_row = true;
            }
          }

          else if (filter.filterType.type === "list") {
           if (filter.filterType.data === "outdoor") {
             temp_category = filter.filterType.data; // "width" or "size"
             temp_value = shoe[temp_category];
             temp_string = Helper.getOutdoorDescription(temp_value);
             let relevantFilterRow=filter.list.filter((selection)=>selection.option===temp_string);
             if(relevantFilterRow.length===0 || !relevantFilterRow[0].value ){
               delete_row = true;
             }
           }
           else if (filter.filterType.data === "size" || filter.filterType.data === "width") {
             temp_category = filter.filterType.data; // "width" or "size"
             temp_value = shoe[temp_category]; // width or size in %
             temp_string = Helper.getSizeDescription(temp_value,temp_category,"very_short")//this.get_size_text(temp_category, temp_value); // string like "narrow", "wide"
             let relevantFilterRow=filter.list.filter((selection)=>selection.option===temp_string);
             if(relevantFilterRow.length===0 || !relevantFilterRow[0].value ){
               delete_row = true;
             }
           }

          else {
           let filteringTerm=shoe[filter.filterType.data]; // for example "Nike" when filtering brand
           let relevantFilterRow=filter.list.filter((selection)=>selection.option===filteringTerm);
           if(relevantFilterRow.length===0 || !relevantFilterRow[0].value ){
             delete_row = true;
           }
         }
       }

       else if (filter.filterType.type === "date") {
         var shoe_date = Helper.getDateFromMysql(shoe.release_date);
         if (eval("filter.date" + filter.sign + "shoe_date")) {
           delete_row = true;
         }
       }

       else if (filter.filterType.type === "bool") {
         if(!filter.value === filter.filterType.checkFunction(shoe)){
           delete_row =true
         }
       }
     })

     if (!delete_row) {
       newData.push(shoe);
     }
   })

   return(newData)
   },

  migrateFilter(filters){
    filters.forEach((filter)=>{
      let tempFilters=JSON.parse(filter.json);
      tempFilters.forEach((tempFilterItem)=>{
        if(typeof(tempFilterItem.list)==="object"){
          let tempNewList=Object.entries(tempFilterItem.list).map((entry)=>({"option":entry[0],"value":entry[1]}));
          tempFilterItem.list=tempNewList
        }
      })
      filter.json=JSON.stringify(tempFilters);
    })
    return(filters);
  },


*/

  get_color: (rating, type = "bg") => {
    if (rating === "NA") {
      return "grey";
    } else rating = Helper.roundto(rating, 1);
    if (type === "bg") {
      if (rating < 6) {
        return "#E53E3E";
      } else if (rating < 8) {
        return "#ED8936";
      } else if (rating <= 10) {
        return "#48BB78";
      }
    } else if (type === "text") {
      if (rating < 6) {
        return "#C53030";
      } else if (rating < 8) {
        return "#D69E2E";
      } else if (rating <= 10) {
        return "#38A169";
      }
    } else if (type === "outdoor") {
      if (rating < 25) {
        return "#E53E3E";
      } else if (rating < 75) {
        return "#ED8936";
      } else if (rating <= 100) {
        return "#48BB78";
      } else {
        return "NA";
      }
    }
  },

  getOutdoorDescription: (rating) => {
    if (rating < 25) {
      return "no";
    } else if (rating < 75) {
      return "fair";
    } else if (rating <= 100) {
      return "good";
    } else {
      return "NA";
    }
  },

  getSizeDescription: (percent, type, length) => {
    if (percent !== "NA") {
      if (percent < 15) {
        return Helper.description[length][type][0];
      } else if (percent < 37.5) {
        return Helper.description[length][type][1];
      } else if (percent < 63.5) {
        return Helper.description[length][type][2];
      } else if (percent < 85) {
        return Helper.description[length][type][3];
      } else {
        return Helper.description[length][type][4];
      }
    }
  },
  getPageArray: (length, shoesPerPage) => {
    let returnValue = [];
    for (let i = 1; i <= Math.ceil(length / shoesPerPage); i++) {
      returnValue.push(i);
    }
    return returnValue;
  },
};

export default Helper;
